import { Blog, Project } from "../pages/pages";
import {
    createBrowserRouter
} from "react-router-dom";
import App from "../App"

export const router = createBrowserRouter([
    {
        path: "/*",
        element: <App />,
        children: [
            {
                path: "project",
                element: <Project />,
            },
            {
                path: "blog",
                element: <Blog />,
            },
        ],
    },

]);